import {
  ASSET_MANAGEMENT_FETCHING,
  ASSET_MANAGEMENT_FAILED,
  ASSET_MANAGEMENT_SUCCESS,
} from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case ASSET_MANAGEMENT_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case ASSET_MANAGEMENT_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case ASSET_MANAGEMENT_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
